export default "__VITE_ASSET__JYACZpdO__"